// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MessagesPage.css */

.list-group-item-action.active {
    background-color: #f0f0f0;
  }
  .speech-bubble {
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 20px 0 0;
    border-color: white transparent transparent transparent;
    top: 0;
    left: 10px;
  }
  .messages-box {
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 10px;
    height: 400px;
    min-height: 300px;
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  
  .message {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #f0f0f0;
  }

  .offer_message{
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #f0f0f0;
  }
  
  .message span {
    font-size: 12px;
    color: #777;
  }
  
  .new-message-box {
    margin-top: 20px;
  }
  
  .new-message-box textarea {
    resize: none;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px;
    width: 100%;
  }
  
  .new-message-box button {
    margin-top: 5px;
  }
  

  /* useEffect(() => {
    socket.on("new_messages", (data) => {
     
      if(selectedChat != 0 && decodedTokenRef.current != null){
        if(data && data.type == "broadcast"){
         
         if(data.receiver == decodedTokenRef.current._id ){
          getMessages();
          getrecentChats();
         }
         

        }else if(data && data.type == "simple"){
          getMessages();
          getrecentChats();
        }

      }
    });
  }, [socket]); */`, "",{"version":3,"sources":["webpack://./src/pages/main/chat/style.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;IACI,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,uDAAuD;IACvD,MAAM;IACN,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;;EAGA;;;;;;;;;;;;;;;;;;;iBAmBe","sourcesContent":["/* MessagesPage.css */\n\n.list-group-item-action.active {\n    background-color: #f0f0f0;\n  }\n  .speech-bubble {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 20px 20px 0 0;\n    border-color: white transparent transparent transparent;\n    top: 0;\n    left: 10px;\n  }\n  .messages-box {\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    padding: 10px;\n    height: 400px;\n    min-height: 300px;\n    max-height: 500px;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n  \n  .message {\n    margin-bottom: 10px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    background-color: #f0f0f0;\n  }\n\n  .offer_message{\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    background-color: #f0f0f0;\n  }\n  \n  .message span {\n    font-size: 12px;\n    color: #777;\n  }\n  \n  .new-message-box {\n    margin-top: 20px;\n  }\n  \n  .new-message-box textarea {\n    resize: none;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 5px;\n    width: 100%;\n  }\n  \n  .new-message-box button {\n    margin-top: 5px;\n  }\n  \n\n  /* useEffect(() => {\n    socket.on(\"new_messages\", (data) => {\n     \n      if(selectedChat != 0 && decodedTokenRef.current != null){\n        if(data && data.type == \"broadcast\"){\n         \n         if(data.receiver == decodedTokenRef.current._id ){\n          getMessages();\n          getrecentChats();\n         }\n         \n\n        }else if(data && data.type == \"simple\"){\n          getMessages();\n          getrecentChats();\n        }\n\n      }\n    });\n  }, [socket]); */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
